import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminalProfile } from '../core/profiles';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_terminal_profile',
};

type Employee = Pick<TTerminalProfile['employees'][number], 'id' | 'name'>;

type UpdatedTerminalProfile = Omit<TTerminalProfile, 'employees'> & {
  employees: Employee[];
};

export const updateTerminalProfileRequest = (body: UpdatedTerminalProfile) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
